import { z } from 'zod';
import { SUPPORTED_RECEIVE_CURRENCIES, SUPPORTED_SEND_CURRENCIES } from '../constants/index.js';

const Amount = z.number().positive().finite().max(1_000_000);

// Send / receive sets are disjoint by construction (M1 corridors are all
// EUR/USD/CAD → XAF), so a same-currency refine would be dead code.
export const TransferCreateSchema = z.object({
  beneficiary_id: z.string().uuid(),
  from_currency: z.enum(SUPPORTED_SEND_CURRENCIES),
  to_currency: z.enum(SUPPORTED_RECEIVE_CURRENCIES),
  amount: Amount,
  /**
   * Client-generated UUID — gates idempotency. The DB has a partial unique
   * index on (user_id, client_idempotency_key) so resubmits are no-ops.
   */
  idempotency_key: z.string().uuid(),
  promo_code: z.string().trim().max(50).optional(),
});
export type TransferCreateInput = z.infer<typeof TransferCreateSchema>;

export const TransferCancelSchema = z.object({
  transfer_id: z.string().uuid(),
});
export type TransferCancelInput = z.infer<typeof TransferCancelSchema>;

// Admin-side: which next status, plus an optional note. Server validates
// that (current → next) is a legal edge in the lifecycle.
export const TransferTransitionSchema = z.object({
  transfer_id: z.string().uuid(),
  to_status: z.enum([
    'PAYMENT_RECEIVED',
    'PROCESSING',
    'PAID_OUT',
    'COMPLETED',
    'CANCELLED',
    'FAILED',
    'REFUNDED',
  ]),
  note: z.string().trim().max(1000).optional(),
});
export type TransferTransitionInput = z.infer<typeof TransferTransitionSchema>;

export const TransferAddNoteSchema = z.object({
  transfer_id: z.string().uuid(),
  note: z.string().trim().min(1).max(1000),
});
export type TransferAddNoteInput = z.infer<typeof TransferAddNoteSchema>;
